import { createAction, props } from '@ngrx/store';

import { UserEntity } from './user-entity.model';

export const setUserEntities = createAction('[User Entities] Set user entities', props<{ userEntities: UserEntity[] }>());
